import React, { useEffect, useState } from "react";
import { navLinks, profile } from "../mock";
import { ArrowUpRight, Download, Menu, X } from "lucide-react";
import { Button } from "./ui/button";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-[#121826]/85 backdrop-blur-md border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="container-x flex items-center justify-between h-16">
        <a href="#top" className="flex items-center gap-2 group">
          <span
            className="w-2 h-2 rounded-full breathe"
            style={{ backgroundColor: "#FF8A5B" }}
          />
          <span className="display text-[16px] tracking-tight text-[#FFF3E9]">
            {profile.name}
          </span>
          <span className="mono text-[10px] text-[#8B7B6E] ml-1 hidden sm:inline">
            / {profile.currentRole}
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-7">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-[13px] text-[#A1A1A6] hover:text-[#EDEDED] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href={profile.cv}
            target="_blank"
            rel="noreferrer"
            data-testid="nav-cv"
            className="inline-flex items-center gap-1.5 text-[13px] text-[#A1A1A6] hover:text-[#EDEDED]"
          >
            <Download className="w-3.5 h-3.5" />
            CV
          </a>
          <Button
            asChild
            size="sm"
            data-testid="nav-cta"
            className="h-9 px-4 rounded-full text-[#121826] font-bold hover:opacity-95"
            style={{
              background:
                "linear-gradient(135deg, #FF8A5B 0%, #FFD2A6 100%)"
            }}
          >
            <a href="#contact" className="flex items-center gap-1">
              Say hi
              <ArrowUpRight className="w-3.5 h-3.5" />
            </a>
          </Button>
        </nav>

        <button
          className="md:hidden p-2 text-[#EDEDED]"
          onClick={() => setOpen((s) => !s)}
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/5 bg-[#121826]">
          <div className="container-x py-4 flex flex-col gap-3">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-[14px] text-[#A1A1A6] py-2"
              >
                {l.label}
              </a>
            ))}
            <a
              href={profile.cv}
              target="_blank"
              rel="noreferrer"
              onClick={() => setOpen(false)}
              className="inline-flex items-center gap-2 text-[14px] text-[#A1A1A6] py-2"
            >
              <Download className="w-3.5 h-3.5" /> Download CV
            </a>
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center gap-1 rounded-full h-10 px-4 text-[13px] font-bold text-[#121826]"
              style={{
                background:
                  "linear-gradient(135deg, #FF8A5B 0%, #FFD2A6 100%)"
              }}
            >
              Say hi <ArrowUpRight className="w-3.5 h-3.5" />
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
